import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OfficeAboutComponent } from './office-about.component';
import { RouterModule, Routes } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { GlobalPipesModule } from '@app/@shared/pipes/globalPipes.module';

const routes: Routes = [
  Shell.childRoutes([
    { path: 'about', component: OfficeAboutComponent, data: { title: marker('About') } },
    { path: ':officeId/about', component: OfficeAboutComponent, data: { title: marker('About') } },
  ]),
];

@NgModule({
  declarations: [OfficeAboutComponent],
  imports: [CommonModule, GlobalPipesModule, RouterModule.forChild(routes)],
})
export class OfficeAboutModule {}
